import { createSlice } from '@reduxjs/toolkit';
import {
  saveSendTimeRestrictions,
  updateMessageOptions,
  setMessageOptionsFormsUpdated,
  fetchCustomerTemplates,
  fetchWhatsAppTemplates,
  fetchUserResponseTemplates,
  saveCustomerTemplate,
  deleteCustomerTemplate,
  fetchUsersOmni,
  sequences,
  uploadAriResponses,
  importAriResponses,
  resetAriImportModalSuccessFlag,
  resetAddAriImportModalSuccessFlag,
  resetTemplateSaveStatus,
  setIsEdittrue,
  setTemplateTypeIsCustomer,
  setTemplateTypeIsCustomerFalse,
  fetchBasicDetails,
  resetBasicDetailsStatus,
  fetchAriIntents,
  fetchVectorSearchResults,
  integrationEvents,
  fetchAriIntentData,
  addAriIntentData,
  downloadAriResponses,
  fetchTermsOfService,
  confirmTermsOfService,
  saveBasicDetails,
  resetIntegrationSettingsStatus,
  setPreferenceDirty,
  resetSearchedUsers,
  fetchCorpusData,
  deleteCorpusData,
  upgradeSequenceToUseKnowledgeBase,
  downloadCorpusData,
  updateSequenceDefinition,
  uploadCorpusData,
  getOrCreateDemoJobchatSequence,
  importStructuredResponses,
  resetUploadCorpusDataStatus,
} from '../actions';
import { dedupeOptions } from 'util/helpers';
import { apiResponse } from 'appConstants';

const initialState = {
  isPreferenceDirty: false,
  isLoading: true,
  isConfirmingTos: false,
  page: 1,
  templates: [],
  templateSave: false,
  templateDeleteStatus: false,
  template: {},
  templatesCount: 0,
  whatsApptemplates: [],
  whatsApptemplatesCount: 0,
  customerWideTosAccepted: false,
  userResponseTemplates: [],
  userResponseTemplatesLoading: true,
  userResponseTemplatesCount: 0,
  searchedUsers: [],
  searchedUsersLoading: false,
  searchedUsersCount: 0,
  whatsAppTemplatesLoading: true,
  isEditStatus: false,
  templateCustomer: false,
  recruitingSequences: [],
  ariSequences: [],
  ariSequencesLoading: false,
  ariResponses: {
    isLoading: false,
    uploadHeaders: [],
    rowCount: 0,
    isError: false,
    isUploaded: false,
    isImportAriSuccess: false,
  },
  isCustomerDetailsPending: false,
  isCustomerDetailsResponded: false,
  name: '',
  seatLicenses: 0,
  usedSeatLicenses: 0,
  addAriIntentsLoading: false,
  ariIntentsLoading: false,
  vectorSearchLoading: false,
  addAriIntentsDataSuccess: false,
  fetchIntentDataLoading: false,
  isTosLoading: false,
  intentsCount: 0,
  intentData: [],
  ariIntentsCount: 0,
  ariIntents: [],
  vectorSearchResults: [],
  integrationEventsList: [],
  integrationEventsCount: 0,
  integrationEventLoading: false,
  integrationEventsError: {},
  filteredIntents: [],
  csvAriData: '',
  icimsPhonePrefix: '',
  icimsCustomFieldAccessUrl: '',
  icimsCustomFieldResponseFlag: '',
  icimsCustomFieldJob: '',
  icimsCustomFieldCandidate: '',
  icimsCustomFieldWorkflow: '',
  icimsIntegration: '',
  icimsUser: '',
  icimsAuthenticationRequired: '',
  integrationDetailsSaved: false,
  userCanManageOptOut: false,
  sendTimeRestriction: {},
  initialOptOutMsg: '',
  usersOmniList: [],
  isGreenhouseIntegration: false,
  isBullhornIntegration: false,
  isUpdatingSequence: false,
  greetingAffirmativeResponse: {
    useDefault: true,
    negativeResponse: '',
  },
  digitalAssistantGreeting: {
    greeting: {},
    privacyUrl: '',
  },
  enableTeams: false,
  isEmailIntegration: false,
  whatsAppBusinessAccountId: '',
  whatsAppSeatLicenses: 0,
  whatsAppUsedSeatLicenses: 0,
  isFetchingCorpusData: false,
  isActivating: false,
  hasActivated: false,
  activationMessage: '',
  activationError: '',
  isDownloadingCorpusData: false,
  hasUploadedCorpusData: false,
  isUploadingCorpusData: false,
  isGettingOrCreatingDemoSequence: false,
  isImportingStructuredResponses: false,
  demoJobchat: {},
  ariContexts: [],
  structuredResponsesAriContexts: [],
  isDeletingCorpusData: false,
  hasDeletedCorpusData: false,
};
const ariUploadRejection = (state, action) => {
  state.ariResponses.isLoading = false;
  state.ariResponses.isError = true;
  state.ariResponses.errorMessage = action.payload.message;
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {},

  // eslint-disable-next-line max-statements
  extraReducers: (builder) => {
    builder.addCase(setMessageOptionsFormsUpdated, (state, action) => {
      state.messageOptionsFormsUpdated = action.payload;
    });

    builder.addCase(saveSendTimeRestrictions.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(saveSendTimeRestrictions.fulfilled, (state) => {
      state.isLoading = false;
      state.sendTimeRestrictionsUpdated = true;
    });

    builder.addCase(saveSendTimeRestrictions.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(updateMessageOptions.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateMessageOptions.fulfilled, (state) => {
      state.isLoading = false;
      // This is to set a unique value each time so that it in turns triggers
      // a necessary another useEffect call in messageOptionsComponents
      state.messageOptionsFormsUpdated = Date.now();
    });

    builder.addCase(updateMessageOptions.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchCustomerTemplates.pending, (state) => {
      state.isLoading = true;
      state.templateSave = false;
      state.templateDeleteStatus = false;
    });

    builder.addCase(fetchCustomerTemplates.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;

      state.templates = action.payload.templates || [];
      state.isLoading = false;
      state.page = page;
      state.templatesCount = items;
    });

    builder.addCase(fetchCustomerTemplates.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchWhatsAppTemplates.pending, (state) => {
      state.whatsAppTemplatesLoading = true;
    });

    builder.addCase(fetchWhatsAppTemplates.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.whatsApptemplates = action.payload.templates || [];
      state.whatsAppTemplatesLoading = false;
      state.page = page;
      state.whatsApptemplatesCount = items;
    });

    builder.addCase(fetchWhatsAppTemplates.rejected, (state, action) => {
      state.whatsAppTemplatesLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchUserResponseTemplates.pending, (state) => {
      state.userResponseTemplatesLoading = true;
      state.templateSave = false;
      state.templateDeleteStatus = false;
    });

    builder.addCase(fetchUserResponseTemplates.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.userResponseTemplates = action.payload.templates || [];
      state.userResponseTemplatesLoading = false;
      state.page = page;
      state.userResponseTemplatesCount = items;
    });

    builder.addCase(fetchUserResponseTemplates.rejected, (state, action) => {
      state.userResponseTemplatesLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchUsersOmni.pending, (state) => {
      state.searchedUsersLoading = true;
    });

    builder.addCase(fetchUsersOmni.rejected, (state, action) => {
      state.searchedUsersLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchUsersOmni.fulfilled, (state, action) => {
      const { paging = {}, results } = action.payload;
      const { resetOptions } = action.meta.arg.params;
      state.searchedUsers = dedupeOptions(resetOptions ? [] : state.searchedUsers, results);
      state.usersOmniList = results;
      state.searchedUsersLoading = false;
      state.searchedUsersCount = paging.items || state.searchedUsers.length;
    });

    builder.addCase(resetSearchedUsers, (state) => {
      state.searchedUsers = [];
    });

    builder.addCase(saveCustomerTemplate.pending, (state) => {
      state.templateSave = false;
      state.templateDeleteStatus = false;
    });

    builder.addCase(saveCustomerTemplate.fulfilled, (state) => {
      state.templateSave = true;
      state.templateDeleteStatus = false;
    });

    builder.addCase(saveCustomerTemplate.rejected, (state, action) => {
      state.error = action.payload.error;
      state.templateSave = false;
    });

    builder.addCase(deleteCustomerTemplate.pending, (state) => {
      state.templateSave = false;
      state.templateDeleteStatus = false;
    });

    builder.addCase(deleteCustomerTemplate.rejected, (state, action) => {
      state.error = action.payload.error;
      state.templateDeleteStatus = false;
    });

    builder.addCase(deleteCustomerTemplate.fulfilled, (state, action) => {
      state.templates = state.templates.filter((element) => element.id !== action.meta.arg);
      state.templateSave = false;
      state.templateDeleteStatus = true;
    });

    builder.addCase(resetTemplateSaveStatus, (state) => {
      state.templateDeleteStatus = false;
      state.templateSave = false;
      state.isEditStatus = false;
    });

    builder.addCase(setIsEdittrue, (state) => {
      state.isEditStatus = true;
    });

    builder.addCase(setTemplateTypeIsCustomer, (state) => {
      state.templateCustomer = true;
    });

    builder.addCase(setTemplateTypeIsCustomerFalse, (state) => {
      state.templateCustomer = false;
    });

    builder.addCase(sequences.pending, (state) => {
      state.ariSequencesLoading = true;
    });

    builder.addCase(sequences.rejected, (state, action) => {
      state.ariSequencesLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(sequences.fulfilled, (state, action) => {
      // For more info on this logic please see TODO task: `Implement the logic to fetch recruiting sequences.`
      // in src/components/Settings/DigitalAssistantKnowledgeBase.js
      const { meta, payload } = action;
      if (meta.arg.hasRecruitingAri) {
        state.recruitingSequences = payload.sequences;
      } else {
        state.ariSequencesLoading = false;
        state.ariSequences = action.payload.sequences ?? [];
      }
    });

    builder.addCase(uploadAriResponses.pending, (state) => {
      state.ariResponses.isLoading = true;
      state.ariResponses.isError = false;
    });

    builder.addCase(uploadAriResponses.fulfilled, (state, action) => {
      state.ariResponses.isLoading = false;
      state.ariResponses.isError = false;
      state.ariResponses.uploadHeaders = action.payload.headers || [];
      state.ariResponses.isUploaded = Boolean(action.payload.headers.length);
      state.ariResponses.rowCount = action.payload.rowCount;
    });

    builder.addCase(uploadAriResponses.rejected, (state, action) => {
      ariUploadRejection(state, action);
    });

    builder.addCase(importAriResponses.pending, (state) => {
      state.ariResponses.isLoading = true;
      state.ariResponses.isError = false;
      state.addAriIntentsDataSuccess = false;
      state.ariResponses.isImportAriSuccess = false;
    });

    builder.addCase(importAriResponses.fulfilled, (state, action) => {
      state.ariResponses.isLoading = false;
      state.ariResponses.isUploaded = false;
      state.addAriIntentsDataSuccess = true;
      state.ariResponses.isImportAriSuccess = Boolean(action.payload.backgroundEventId);
    });

    builder.addCase(importAriResponses.rejected, (state, action) => {
      state.ariResponses.isUploaded = false;
      ariUploadRejection(state, action);
      state.addAriIntentsDataSuccess = false;
    });

    builder.addCase(resetAriImportModalSuccessFlag, (state) => {
      state.ariResponses.isImportAriSuccess = false;
    });

    builder.addCase(fetchBasicDetails.pending, (state) => {
      state.isCustomerDetailsPending = true;
      state.isCustomerDetailsResponded = false;
      state.integrationDetailsSaved = false;
    });

    builder.addCase(fetchBasicDetails.fulfilled, (state, action) => {
      const {
        name,
        usedSeatLicenses,
        seatLicenses,
        icimsPhonePrefix,
        icimsCustomFieldAccessUrl,
        icimsCustomFieldResponseFlag,
        icimsCustomFieldJob,
        icimsCustomFieldCandidate,
        icimsCustomFieldWorkflow,
        icimsIntegration,
        emailIntegration,
        icimsUser,
        icimsAuthenticationRequired,
        userCanManageOptOut,
        initialOptOutMsg,
        sendTimeRestriction,
        greenhouseIntegration,
        bullhornIntegration,
        enableTeams,
        tosId,
        customerWideTosAccepted,
        whatsAppBusinessAccountId,
        whatsAppSendersLimit,
        registeredWhatsAppSenders,
      } = action.payload.customer;
      state.name = name;
      state.usedSeatLicenses = usedSeatLicenses;
      state.seatLicenses = seatLicenses;
      state.isCustomerDetailsPending = false;
      state.isCustomerDetailsResponded = true;
      state.icimsPhonePrefix = icimsPhonePrefix;
      state.icimsCustomFieldAccessUrl = icimsCustomFieldAccessUrl;
      state.icimsCustomFieldResponseFlag = icimsCustomFieldResponseFlag;
      state.icimsCustomFieldJob = icimsCustomFieldJob;
      state.icimsCustomFieldCandidate = icimsCustomFieldCandidate;
      state.icimsCustomFieldWorkflow = icimsCustomFieldWorkflow;
      state.icimsIntegration = icimsIntegration;
      state.isEmailIntegration = emailIntegration;
      state.icimsUser = icimsUser;
      state.icimsAuthenticationRequired = icimsAuthenticationRequired;
      state.userCanManageOptOut = userCanManageOptOut;
      state.initialOptOutCustomisedMessage = initialOptOutMsg;
      state.sendTimeRestriction = sendTimeRestriction || {};
      state.isGreenhouseIntegration = greenhouseIntegration;
      state.isBullhornIntegration = bullhornIntegration;
      state.enableTeams = enableTeams;
      state.termsOfServiceRecordId = tosId;
      state.customerWideTosAccepted = Boolean(customerWideTosAccepted);
      state.whatsAppBusinessAccountId = whatsAppBusinessAccountId;
      state.whatsAppSeatLicenses = whatsAppSendersLimit;
      state.whatsAppUsedSeatLicenses = registeredWhatsAppSenders;
    });

    builder.addCase(fetchBasicDetails.rejected, (state, action) => {
      state.isCustomerDetailsPending = false;
      state.error = action.payload.error;
      state.isCustomerDetailsResponded = false;
    });

    builder.addCase(resetBasicDetailsStatus, (state) => {
      state.isCustomerDetailsPending = false;
      state.isCustomerDetailsResponded = false;
    });

    builder.addCase(fetchAriIntents.pending, (state) => {
      state.ariIntentsLoading = true;
    });

    builder.addCase(fetchAriIntents.rejected, (state, action) => {
      state.ariIntentsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchAriIntents.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.ariIntentsLoading = false;
      state.ariIntents = action.payload.intents;
      state.page = page;
      state.ariIntentsCount = items;
    });

    builder.addCase(fetchVectorSearchResults.pending, (state) => {
      state.vectorSearchLoading = true;
    });

    builder.addCase(fetchVectorSearchResults.fulfilled, (state, action) => {
      state.vectorSearchLoading = false;
      state.vectorSearchResults = action.payload;
    });

    builder.addCase(fetchVectorSearchResults.rejected, (state, action) => {
      state.vectorSearchLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchAriIntentData.pending, (state) => {
      state.fetchIntentDataLoading = true;
      state.intentData = [];
    });

    builder.addCase(fetchAriIntentData.rejected, (state, action) => {
      state.fetchIntentDataLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchAriIntentData.fulfilled, (state, action) => {
      state.fetchIntentDataLoading = false;
      state.intentData = action.payload.intents;
    });

    builder.addCase(addAriIntentData.pending, (state) => {
      state.addAriIntentsLoading = true;
      state.addAriIntentsDataSuccess = false;
    });

    builder.addCase(addAriIntentData.rejected, (state, action) => {
      state.addAriIntentsDataSuccess = false;
      state.error = action.payload.error;
    });

    builder.addCase(addAriIntentData.fulfilled, (state) => {
      state.addAriIntentsDataSuccess = true;
    });

    builder.addCase(resetAddAriImportModalSuccessFlag, (state) => {
      state.addAriIntentsDataSuccess = false;
    });

    builder.addCase(integrationEvents.pending, (state) => {
      state.integrationEventLoading = true;
      state.integrationEventsList = [];
    });

    builder.addCase(integrationEvents.fulfilled, (state, action) => {
      state.integrationEventLoading = false;
      state.integrationEventsList = action.payload.events;
      state.integrationEventsCount = action.payload.paging.items;
      state.integrationEventsError = {};
    });

    builder.addCase(integrationEvents.rejected, (state, action) => {
      state.integrationEventLoading = false;
      state.integrationEventsError = action.payload.error;
    });

    builder.addCase(downloadAriResponses.pending, (state) => {
      state.ariIntentsLoading = false;
    });

    builder.addCase(downloadAriResponses.rejected, (state, action) => {
      state.ariIntentsLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(downloadAriResponses.fulfilled, (state, action) => {
      state.ariIntentsLoading = false;
      state.csvAriData = action.payload;
    });

    builder.addCase(fetchTermsOfService.pending, (state) => {
      state.isTosLoading = true;
    });

    builder.addCase(fetchTermsOfService.rejected, (state, action) => {
      state.isTosLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchTermsOfService.fulfilled, (state, action) => {
      state.isTosLoading = false;
      state.termsOfServiceRecord = action.payload.tos;
    });

    builder.addCase(confirmTermsOfService.pending, (state) => {
      state.isConfirmingTos = true;
    });

    builder.addCase(confirmTermsOfService.rejected, (state, action) => {
      state.isConfirmingTos = false;
      state.error = action.payload.error;
    });

    builder.addCase(confirmTermsOfService.fulfilled, (state) => {
      state.isConfirmingTos = false;
    });

    builder.addCase(saveBasicDetails.pending, (state) => {
      state.loading = true;
      state.integrationDetailsSaved = false;
    });

    builder.addCase(saveBasicDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });

    builder.addCase(saveBasicDetails.fulfilled, (state) => {
      state.loading = false;
      state.error = '';
      state.integrationDetailsSaved = true;
    });

    builder.addCase(resetIntegrationSettingsStatus, (state) => {
      state.integrationDetailsSaved = false;
    });

    builder.addCase(setPreferenceDirty, (state, action) => {
      state.isPreferenceDirty = action.payload;
    });

    builder.addCase(fetchCorpusData.pending, (state) => {
      state.isFetchingCorpusData = true;
    });

    builder.addCase(fetchCorpusData.rejected, (state, action) => {
      state.isFetchingCorpusData = false;
      state.error = action.payload.error;
    });

    builder.addCase(fetchCorpusData.fulfilled, (state, action) => {
      const { ariContexts } = action.payload;
      const { source } = action.meta.arg;

      if (source === 'ariResponses') {
        state.structuredResponsesAriContexts = ariContexts;
      } else {
        state.ariContexts = ariContexts;
      }
      state.isFetchingCorpusData = false;
    });

    builder.addCase(downloadCorpusData.pending, (state) => {
      state.isDownloadingCorpusData = true;
    });

    builder.addCase(downloadCorpusData.rejected, (state, action) => {
      state.isDownloadingCorpusData = false;
      state.error = action.payload.error;
    });

    builder.addCase(downloadCorpusData.fulfilled, (state) => {
      state.isDownloadingCorpusData = false;
    });

    builder.addCase(deleteCorpusData.pending, (state) => {
      state.isDeletingCorpusData = true;
      state.hasDeletedCorpusData = false;
    });

    builder.addCase(deleteCorpusData.rejected, (state, action) => {
      state.isDeletingCorpusData = false;
      state.hasDeletedCorpusData = false;
      state.error = action.payload.error;
    });

    builder.addCase(deleteCorpusData.fulfilled, (state, action) => {
      const { ariContext } = action.payload;

      state.ariContext = ariContext;
      state.isDeletingCorpusData = false;
      state.hasDeletedCorpusData = true;
    });

    builder.addCase(updateSequenceDefinition.pending, (state) => {
      state.isUpdatingSequence = true;
    });

    builder.addCase(updateSequenceDefinition.rejected, (state, action) => {
      state.isUpdatingSequence = false;
      state.error = action.payload.error;
    });

    builder.addCase(updateSequenceDefinition.fulfilled, (state, action) => {
      const { digitalAssistantGreeting, greetingAffirmativeResponse } = action.payload;
      state.digitalAssistantGreeting = digitalAssistantGreeting;
      state.greetingAffirmativeResponse = greetingAffirmativeResponse;
      state.isUpdatingSequence = false;
    });

    builder.addCase(upgradeSequenceToUseKnowledgeBase.pending, (state) => {
      state.isActivating = true;
      state.activationMessage = '';
      state.activationError = '';
    });

    builder.addCase(upgradeSequenceToUseKnowledgeBase.rejected, (state, action) => {
      state.isActivating = false;
      state.hasActivated = false;
      state.activationMessage = 'activation_error';
      state.activationError = action.payload.error;
      state.error = action.payload.error;
    });

    builder.addCase(upgradeSequenceToUseKnowledgeBase.fulfilled, (state, action) => {
      const { ariContext, apiResult } = action.payload;
      state.ariContext = ariContext;
      state.isActivating = false;

      // Handle activation response based on API result
      if (apiResult?.status === apiResponse.SUCCESS) {
        state.hasActivated = true;
        state.activationMessage = 'digital_assistant_qa_knowledge_base_live';
        state.activationError = '';
      } else if (apiResult?.status === apiResponse.ERROR) {
        state.hasActivated = false;
        state.activationError = '';

        if (apiResult.message === 'No upgrade occurred') {
          state.activationMessage = 'no_upgrade_occurred';
        } else if (apiResult.message === 'Customer is not eligible for recruiting demo') {
          state.activationMessage = 'customer_is_not_eligible_for_recruiting_demo';
        } else {
          state.activationMessage = 'activation_failed';
        }
      } else {
        // Handle unexpected response structure
        state.hasActivated = false;
        state.activationMessage = 'activation_failed';
        state.activationError = '';
      }
    });

    builder.addCase(uploadCorpusData.pending, (state) => {
      state.isUploadingCorpusData = true;
      state.hasUploadedCorpusData = false;
    });

    builder.addCase(uploadCorpusData.rejected, (state, action) => {
      state.isUploadingCorpusData = false;
      state.hasUploadedCorpusData = false;
      state.error = action.payload.error;
    });

    builder.addCase(uploadCorpusData.fulfilled, (state, action) => {
      const { ariContexts } = action.payload;

      state.ariContexts = ariContexts;
      state.isUploadingCorpusData = false;
      state.hasUploadedCorpusData = true;
    });

    builder.addCase(resetUploadCorpusDataStatus, (state) => {
      state.hasUploadedCorpusData = false;
    });

    builder.addCase(getOrCreateDemoJobchatSequence.pending, (state) => {
      state.isGettingOrCreatingDemoSequence = true;
    });

    builder.addCase(getOrCreateDemoJobchatSequence.rejected, (state, action) => {
      state.isGettingOrCreatingDemoSequence = false;
      state.error = action.payload.error;
    });

    builder.addCase(getOrCreateDemoJobchatSequence.fulfilled, (state, action) => {
      const { jobChat } = action.payload;

      state.demoJobchat = jobChat;
      state.isGettingOrCreatingDemoSequence = false;
    });

    builder.addCase(importStructuredResponses.pending, (state) => {
      state.isImportingStructuredResponses = true;
    });

    builder.addCase(importStructuredResponses.rejected, (state, action) => {
      state.isImportingStructuredResponses = false;
      state.error = action.payload.error;
    });

    builder.addCase(importStructuredResponses.fulfilled, (state, action) => {
      const { ariContexts } = action.payload;

      state.ariContexts = ariContexts;
      state.isImportingStructuredResponses = false;
    });
  },
});

export default customerSlice;
